import React from 'react';

// Components
import { PrimaryButton, CancelButton } from '../buttons';
import { AdvancedSearch } from '../search';
import Modal from '@/views/components/modals/AccessibleModal';

// Libraries
import classNames from 'classnames';

// Utils
import { ADVANCED_SEARCH_OPTIONS } from '@/utils/constants';

// Legacy Support
import LegacyAdvancedSearchModal from './LegacyAdvancedSearchModal';
import withLegacyVersion from '../hocs/withLegacyVersion';

type Props = {
  className?: string;
  onConfirm: () => void;
  onCancel: () => void;
  show: boolean;
  selectedOption?: ADVANCED_SEARCH_OPTIONS;
  actionDisabled: boolean;
  actionLabel: string;
  onChangeOption?: (option: ADVANCED_SEARCH_OPTIONS) => void;
};

const AdvancedSearchModal = ({
  className,
  onCancel = () => {},
  onConfirm = () => {},
  selectedOption,
  show = false,
  actionDisabled,
  actionLabel,
  onChangeOption,
}: Props) => (
  <Modal show={show} className={classNames('advanced-search-modal-v2', className)} onHide={onCancel}>
    <Modal.Body className="d-flex flex-column">
      <AdvancedSearch selectedOption={selectedOption} insideModal onChangeOption={onChangeOption} />
    </Modal.Body>

    <Modal.Footer className="justify-content-end">
      <CancelButton onClick={onCancel} />

      <PrimaryButton onClick={onConfirm} disabled={actionDisabled}>
        <span>{actionLabel}</span>
      </PrimaryButton>
    </Modal.Footer>
  </Modal>
);

export default withLegacyVersion(AdvancedSearchModal, LegacyAdvancedSearchModal);
